import { ChangeDetectionStrategy, Component, inject } from '@angular/core';
import { Router } from '@angular/router';
import { FormBuilder, FormGroup } from '@angular/forms';
import {
  BuildingApplicationFilterDto,
  BuildingApplicationItemDto,
  BuildingApplicationService,
  TenantMergeDto
} from '@artemis-software/wr-api';
import { currentTenantId } from '@/utils/admin-utils';
import TenantTypeEnum = TenantMergeDto.TenantTypeEnum;

@Component({
  standalone: false,
  selector: 'wr-building-application-admin-overview',
  templateUrl: './building-application-admin-overview.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class BuildingApplicationAdminOverviewComponent {

  private readonly router = inject(Router);
  private readonly formBuilder = inject(FormBuilder);
  private readonly buildingApplicationService = inject(BuildingApplicationService);
  protected readonly TenantTypeEnum = TenantTypeEnum;
  readonly tenantId = currentTenantId();

  form: FormGroup;

  readonly loadBuildingApplications = (filter: BuildingApplicationFilterDto) => {
    const mergedFilter: BuildingApplicationFilterDto = {
      ...filter,
    };
    return this.buildingApplicationService.findAll({ ...mergedFilter });
  };

  readonly getCount = (filter: BuildingApplicationFilterDto) =>{
    const mergedFilter: BuildingApplicationFilterDto = {
      ...filter,
    };
    return this.buildingApplicationService.getCount({ ...mergedFilter });
  };

  constructor() {
    this.form = this.formBuilder.group({
      textFilter: this.formBuilder.control(''),
      ownerTenantId: this.formBuilder.control<string | null>(null),
      status: this.formBuilder.control<string | null>(null),
    });
  }

  navigateToBuildingApplication(event: BuildingApplicationItemDto): void {
    this.router.navigate(['buildingApplicationAdmin', event.id]);
  }

}
